import './NotFound.scss';

export function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found__content">
        <h1 className="not-found__title">404</h1>
        <p className="not-found__subtitle">Page introuvable</p>
        <p className="not-found__description">
          La page que vous recherchez n&apos;existe pas ou a été déplacée.
        </p>
        <a href="/" className="not-found__link">
          Retour à l&apos;accueil
        </a>
      </div>
    </div>
  );
}

export default NotFound;
